module.exports = "mutation UpdateCustomerComment($customer:UpdateCustomerCommentInput!){updateCustomerComment(customer:$customer){success}}"